import React from 'react';
import { ExternalLink, Shield } from 'lucide-react';

const TREASURY_ADDRESS =
  process.env.REACT_APP_TREASURY_ADDRESS ||
  '0xb1bAd50c671CD4c4387f51564Bcc780c262512B1';

// Mini lobster for footer
const MiniLobster = () => (
  <svg viewBox="0 0 120 140" className="w-8 h-9" fill="none">
    <ellipse cx="60" cy="85" rx="35" ry="45" fill="#ff3b3b" />
    <ellipse cx="60" cy="45" rx="25" ry="25" fill="#ff3b3b" />
    <circle cx="50" cy="40" r="6" fill="#0a0a0f" />
    <circle cx="70" cy="40" r="6" fill="#0a0a0f" />
    <circle cx="51" cy="38" r="2" fill="white" />
    <circle cx="71" cy="38" r="2" fill="white" />
    <path d="M45 25 Q35 10 25 15" stroke="#ff3b3b" strokeWidth="4" strokeLinecap="round" fill="none" />
    <path d="M75 25 Q85 10 95 15" stroke="#ff3b3b" strokeWidth="4" strokeLinecap="round" fill="none" />
    <circle cx="25" cy="15" r="4" fill="#ff3b3b" />
    <circle cx="95" cy="15" r="4" fill="#ff3b3b" />
    <ellipse cx="20" cy="80" rx="15" ry="10" fill="#ff3b3b" transform="rotate(-20 20 80)" />
    <ellipse cx="100" cy="80" rx="15" ry="10" fill="#ff3b3b" transform="rotate(20 100 80)" />
    <ellipse cx="60" cy="115" rx="20" ry="8" fill="#e63535" />
    <ellipse cx="60" cy="125" rx="16" ry="6" fill="#cc2f2f" />
    <ellipse cx="60" cy="133" rx="12" ry="5" fill="#b32929" />
  </svg>
);

const Footer = ({ lastBuyback, isMockMode }) => {
  const truncateHash = (hash) => {
    if (!hash) return '';
    return `${hash.slice(0, 10)}...${hash.slice(-8)}`;
  };

  return (
    <footer className="py-16 px-6 border-t border-white/5 relative z-10">
      <div className="max-w-4xl mx-auto">
        {/* Transparency Section */}
        <div className="glass-card p-8 mb-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 rounded-lg bg-[#ff3b3b]/20">
              <Shield className="w-5 h-5 text-[#ff3b3b]" />
            </div>
            <h3 className="text-xl font-display font-bold text-white">Transparency</h3>
          </div>
          
          <p className="text-white/50 mb-6">
            New launched memes fees will be used to buyback $CFACTORY tokens in ETH.
          </p>

          {/* Treasury wallet */}
          {TREASURY_ADDRESS ? (
            <div className="bg-white/5 rounded-xl p-4 inline-block mb-4">
              <p className="text-white/40 text-xs uppercase tracking-wider mb-2">Treasury Wallet</p>
              <div className="flex items-center gap-3">
                <code className="text-[#ff3b3b] text-sm font-mono">
                  {truncateHash(TREASURY_ADDRESS)}
                </code>
                <a
                  href={`https://basescan.org/address/${TREASURY_ADDRESS}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/40 hover:text-[#ff3b3b] transition-colors"
                  title="View treasury on BaseScan"
                >
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </div>
          ) : null}

          {/* Last Buyback */}
          {lastBuyback && (
            <div className="bg-white/5 rounded-xl p-4 inline-block">
              <p className="text-white/40 text-xs uppercase tracking-wider mb-2">
                Last Buyback Transaction
              </p>
              <div className="flex items-center gap-3">
                <code className="text-[#ff3b3b] text-sm font-mono">
                  {truncateHash(lastBuyback.tx_hash)}
                </code>
                <a
                  href={`https://basescan.org/tx/${lastBuyback.tx_hash}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/40 hover:text-[#ff3b3b] transition-colors"
                >
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>
              <p className="text-white/30 text-xs mt-2 flex items-center gap-2">
                <span>{lastBuyback.amount_eth} ETH</span>
                <a
                  href={`https://basescan.org/tx/${lastBuyback.tx_hash}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/40 hover:text-[#ff3b3b] transition-colors"
                  title="View buyback on BaseScan"
                >
                  <ExternalLink className="w-3 h-3" />
                </a>
              </p>
            </div>
          )}
        </div>

        {/* Footer Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <MiniLobster />
            <span className="text-white/60 text-sm">
              ClawdFactory © 2026
            </span>
          </div>

          <div className="flex items-center gap-6">
            {isMockMode && (
              <span className="px-3 py-1 bg-yellow-500/20 text-yellow-500 text-xs uppercase rounded-lg font-semibold">
                Mock Mode
              </span>
            )}
            <a
              href="https://basescan.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-white text-sm transition-colors"
            >
              BaseScan
            </a>
            <a
              href="https://x.com/clawdfactory"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-white text-sm transition-colors"
            >
              X (Twitter)
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
